import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Grid,
    Slide,
    Typography,
    FormControl,
    Button
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment'
import WrappedAutocomplete from 'common/components/custom/WrappedAutocomplete'
import WrappedKeyboardDatePicker from 'common/components/custom/WrappedKeyboardDatePicker';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[400],
    },
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

class AssetHistoryEmployeeEditDialog extends Component {


    render() {
        const { employeesList, employeeHistoryEditDialog, selectedEmployeeEdit, selectedEmployeeStartDateEdit, selectedIssuedByEdit } = this.props

        return (
            <Dialog onClose={this.closeEmployeeHistoryDialog} open={employeeHistoryEditDialog} TransitionComponent={Transition} fullWidth maxWidth="sm">
                <DialogTitle className="dialog-header-custom">{this.props.t("edit_asset_employee_history")}</DialogTitle>
                <form onSubmit={this.props.updateEmployeeHistory} autoComplete="off" spellCheck="false">
                    <DialogContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <WrappedKeyboardDatePicker
                                            name="selectedEmployeeStartDateEdit"
                                            label={this.props.t("starting_date_of_usage")}
                                            value={selectedEmployeeStartDateEdit ? moment(selectedEmployeeStartDateEdit, "DD-MM-YYYY") : null}
                                            onChange={this.props.handleChangeEmployeeEditStartDate}
                                        />
                                    </Grid>
                                    <Grid item container>
                                        <FormControl variant="outlined" fullWidth>
                                            <WrappedAutocomplete
                                                label={this.props.t("employee")}
                                                placeholder={this.props.t("employee")}
                                                name="selectedEmployee"
                                                value={selectedEmployeeEdit}
                                                options={employeesList}
                                                onChange={this.props.handleChangeEmployeeEdit}
                                                getOptionLabel={option => option.firstName && option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.firstName + " " + option.lastName}
                                                getOptionSelected={(option, value) => option.id === value.id}
                                                renderOption={option => (
                                                    <React.Fragment>
                                                        {option.firstName && option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.firstName + " " + option.lastName}
                                                    </React.Fragment>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item container>
                                        <FormControl variant="outlined" fullWidth>
                                            <WrappedAutocomplete
                                                label={this.props.t("issued_by")}
                                                placeholder={this.props.t("issued_by")}
                                                name="selectedIssuedBy"
                                                value={selectedIssuedByEdit}
                                                options={employeesList}
                                                onChange={this.props.handleChangeIssuedByEdit}
                                                getOptionLabel={option => option.firstName && option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.firstName + " " + option.lastName}
                                                getOptionSelected={(option, value) => option.id === value.id}
                                                renderOption={option => (
                                                    <React.Fragment>
                                                        {option.firstName && option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.firstName + " " + option.lastName}
                                                    </React.Fragment>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent >
                    <DialogActions className={"dialog-actions-fix"}>
                        <Button color="inherit" onClick={this.props.closeEmployeeHistoryDialog} variant="contained">
                            {this.props.t("close")}
                        </Button>
                        <Button type="submit" color="primary" variant="contained" /* disabled={this.props.disabledEmployeeEditButton} */>
                            {this.props.t("update")}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        );
    }
}

export default withRouter(withTranslation()(AssetHistoryEmployeeEditDialog));